module.exports = __webpack_public_path__ + "img/logout.a43c5450.svg";